import s from './scss/zoomcontrols.scss';
import cn from 'classnames';

const ZoomControls = ({ zoomClicked, zoomStatus }) => {
  return (
    <div className={cn(s.buttonwrapper)}>
      {zoomStatus === true && (
        <div className={cn(s.button, s.plus)} onClick={() => zoomClicked(1)}>
          <div className={s.icon} />
        </div>
      )}
      {zoomStatus === false && (
        <div className={cn(s.button, s.minus)} onClick={() => zoomClicked(-1)}>
          <div className={s.icon} />
        </div>
      )}
    </div>
  );
};

export default ZoomControls;
